import { render, staticRenderFns } from "./Level.vue?vue&type=template&id=fd08c3b8&scoped=true"
import script from "./Level.vue?vue&type=script&lang=js"
export * from "./Level.vue?vue&type=script&lang=js"
import style0 from "./Level.vue?vue&type=style&index=0&id=fd08c3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd08c3b8",
  null
  
)

export default component.exports